var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M16.266 6a2.8 2.8 0 1 0 .001 5.599h2.8V8.8A2.8 2.8 0 0 0 16.268 6Zm0 7.467H8.8a2.8 2.8 0 0 0 0 5.6h7.466a2.8 2.8 0 1 0 0-5.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M34 16.266a2.8 2.8 0 0 0-5.6 0v2.8h2.8a2.8 2.8 0 0 0 2.8-2.8m-7.467 0V8.8a2.8 2.8 0 0 0-5.6 0v7.467a2.8 2.8 0 1 0 5.6 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M23.733 34a2.8 2.8 0 1 0 0-5.599h-2.8v2.8a2.8 2.8 0 0 0 2.8 2.799m0-7.468h7.466a2.8 2.8 0 0 0 .002-5.6h-7.467a2.8 2.8 0 0 0-.001 5.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M6 23.733a2.8 2.8 0 0 0 5.6 0v-2.8H8.8a2.8 2.8 0 0 0-2.8 2.8m7.467 0v7.466a2.8 2.8 0 0 0 5.6.002v-7.466a2.8 2.8 0 0 0-5.6-.002"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slack.36b5dcea.svg";